// ABOUTME: Records a product event (e.g. the shortlist CSV export) through POST /events (or /events/shared/:id from a share link), from this device and visit.
// ABOUTME: Fire and forget: it never throws and nothing waits on it, so tracking can't break what the user did.
import { sessionHeaders } from './sessionIds';

/** Names must be on the backend's allow-list (backend/src/modules/events/dto/track-event.dto.ts). */
export type TrackedEvent = 'shortlist_csv.exported';

/** Ids, counts and short labels only: the backend refuses nested values and long strings. */
export type EventProperties = Record<string, string | number | boolean | null>;

/** shareReferenceId: the event comes from that public share link; the backend counts it against the shared position. */
export const trackEvent = (
  name: TrackedEvent,
  properties: EventProperties,
  shareReferenceId?: string
): void => {
  try {
    const token = localStorage.getItem('id_token');
    const path = shareReferenceId
      ? `/events/shared/${encodeURIComponent(shareReferenceId)}`
      : '/events';
    fetch(`${import.meta.env.REACT_APP_API_URL}${path}`, {
      method: 'POST',
      // The event still arrives if the click navigates away.
      keepalive: true,
      headers: {
        'Content-Type': 'application/json',
        ...(token && { Authorization: `Bearer ${token}` }),
        ...sessionHeaders(),
      },
      body: JSON.stringify({ name, properties }),
    }).catch(() => undefined);
  } catch {
    // Tracking must never surface to the user.
  }
};
